import { Component, OnInit, input } from '@angular/core';
import { ApplyPanelComponent, CheckboxComponent, ColorPickerComponent } from '@imagise/shared';
import { TranslateModule } from '@ngx-translate/core';
import { EditMode } from '../../../domain/enums/editor.enum';
import { EditorDeskewDraftOperation } from '../../../domain';
import { Size2D } from '../../../domain/interfaces/shared';
import { EditOptionsPanelBase } from '../edit-options-panel.base';
import { PanelLayoutComponent } from '../panel-layout/panel-layout.component';

const DEFAULT_RESIZE_PROPORTIONALLY = true;
const DEFAULT_BACKGROUND_COLOR = '#ffffff';
const DEFAULT_TRANSPARENT_BACKGROUND = true;

@Component({
  selector: 'lib-deskew-panel',
  host: {
    class: 'contents',
  },
  templateUrl: './deskew-panel.component.html',
  imports: [ApplyPanelComponent, CheckboxComponent, ColorPickerComponent, PanelLayoutComponent, TranslateModule],
})
export class DeskewPanelComponent extends EditOptionsPanelBase<EditorDeskewDraftOperation> implements OnInit {
  readonly imageSize = input<Size2D | null>(null);

  resizeProportionally = DEFAULT_RESIZE_PROPORTIONALLY;
  backgroundColor = DEFAULT_BACKGROUND_COLOR;
  useTransparentBackground = DEFAULT_TRANSPARENT_BACKGROUND;

  ngOnInit(): void {
    this.emitDeskewOptions();
  }

  onResizeProportionallyChanged(checked: boolean): void {
    this.resizeProportionally = checked;
    this.emitDeskewOptions();
  }

  onTransparentBackgroundChanged(checked: boolean): void {
    this.useTransparentBackground = checked;
    this.emitDeskewOptions();
  }

  onBackgroundColorChanged(value: string): void {
    this.backgroundColor = value;
    this.useTransparentBackground = false;
    this.emitDeskewOptions();
  }

  protected refresh(): void {
    this.resizeProportionally = DEFAULT_RESIZE_PROPORTIONALLY;
    this.backgroundColor = DEFAULT_BACKGROUND_COLOR;
    this.useTransparentBackground = DEFAULT_TRANSPARENT_BACKGROUND;
    this.emitDeskewOptions();
  }

  private emitDeskewOptions(): void {
    this.changed.emit({
      kind: 'deskew',
      mode: EditMode.Deskew,
      params: {
        resizeProportionally: this.resizeProportionally,
        backgroundColor: this.useTransparentBackground ? null : this.backgroundColor,
      },
    });
  }
}
